export default __webpack_public_path__ + "static/media/automotive_background.360a2944.jpg";